import type { FaireProductEntity } from "../../entity_types/product";

export const p_4t839xds77: FaireProductEntity = {
  token: "p_4t839xds77",
  type: "product",
  name: "Ceramic Pink Cappuccino Cup, 2.9 x 3.9 Inches  ",
  brandToken: "b_9f715f8d",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/e7d3798e58d9c9c48b28a2562516efeb2b549d2aeb2640af208bf1716261bae9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65e5485e3ea6f1f66ced9eb0474576c91fc7607aec8aa442ec3f240bbfd58ffc.jpeg",
    "https://cdn.faire.com/fastly/4d9e188c8f1ebccd4a0116f3870a2ba8a16a5eabd36bc525b799670ff93a54be.jpeg",
    "https://cdn.faire.com/fastly/1aee364d1e3110efbce1030400867713ce9468a4dec8b5302fa2e426a10adb5a.png",
  ],
  priceDollars: 19,
  description:
    "Elevate your coffee or tea game with the Casa Amarosa ceramic wavy tea coffee cup. \n\nMade from high-quality ceramic material, this cup is sleek and durable, perfect for any modern home or office. The wide opening and ergonomic handle make it easy and comfortable to use. \n\nThis ceramic tea coffee cup is not only practical but also a great way to add some style to your summer routine. It's the perfect gift for anyone who loves unique and sophisticated drinkware. Order now and elevate your coffee or tea game with this sleek and modern ceramic coffee cup from Casa Amarosa.\n\n•  Material -  Ceramic\n•  Size-  2.9 x 3.9 Inches\n•  Color -Pink\n•  Dishwasher and Microwave safe\n•  Hand Made by artisan\n•  Perfect Cup for Coffee & Tea\n\nGift, Hostess",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.629Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
